<template>
  <div v-if="showDialog">
    <brazil-v-dialog
      v-if="showMobile"
      :value="showDialog"
      width="600px"
      @change="closeModal"
    >
      <div id="dialog-body">
        <div id="dialog-top">
          <span
            id="dialog-title"
            v-html="translate('title')"
          />
          <template v-for="(installment, index) in paymentPlan.installments">
            <div :key="index">
              <table
                class="installment-row"
                :class="installmentStatus(installment)"
              >
                <tr>
                  <td v-html="translate('date')" />
                  <td
                    class="date align-right"
                    v-html="formatDate(installment.due_date)"
                  />
                </tr>
                <tr>
                  <td v-html="translate('installment_amount')" />
                  <td
                    class="align-right"
                    v-html="formatAmount(installment.installment_amount)"
                  />
                </tr>
                <tr>
                  <td />
                  <td
                    :class="statusClass(installmentStatus(installment), index)"
                    class="align-right"
                    v-html="translateStatus(installmentStatus(installment))"
                  />
                </tr>
              </table>
              <hr>
            </div>
          </template>
        </div>
        <div id="dialog-middle">
          <div id="next-payment-container">
            <span
              id="next-payment-title"
              v-html="translate('next_payment')"
            />
            <span
              id="next-payment-amount"
              v-html="formatAmount(nextInstallment.installment_amount)"
            />
            <hr>
            <span
              id="next-payment-date-title"
              v-html="translate('date')"
            />
            <span
              id="next-payment-date"
              v-html="formatDate(nextInstallment.due_date)"
            />
          </div>
          <div id="action-buttons">
            <div id="download-pdf-container">
              <brazil-v-btn
                class="primary-button"
                :loading="loadingPdf"
                :disabled="loadingPdf"
                @click="downloadPdf(nextInstallment.due_date)"
                v-html="showPdfText"
              />
            </div>
            <div id="copy-barcode-container">
              <span
                v-if="showCopyBarcodeErrorMessage"
                id="copy-barcode-error-message"
                class="red-error-message"
                v-html="translate('generic_error')"
              />
              <v-tooltip
                v-model="showBarcodeToolTip"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <brazil-v-btn
                    ref="copyBarcodeButton"
                    class="secondary-button"
                    :loading="loadingBarcode"
                    :disabled="loadingBarcode"
                    v-bind="attrs"
                    @click="copyBarcode(nextInstallment.due_date)"
                    v-on="on"
                  >
                    {{ copyButtonText }}
                  </brazil-v-btn>
                </template>
                <span v-html="translate('copied')" />
              </v-tooltip>
            </div>
            <div
              id="email-button-container"
            >
              <span
                v-if="showEmailErrorMessage"
                id="email-error-message"
                class="red-error-message"
                v-html="translate('generic_error')"
              />
              <v-tooltip
                v-model="showEmailedToolTip"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <brazil-v-btn
                    ref="emailButton"
                    class="secondary-button"
                    :loading="loadingEmail"
                    :disabled="loadingEmail"
                    v-bind="attrs"
                    @click="sendEmail"
                    v-on="on"
                  >
                    {{ translate('email') }}
                  </brazil-v-btn>
                </template>
                <span v-html="translate('emailed')" />
              </v-tooltip>
            </div>
          </div>
        </div>
        <hr>
        <div
          id="dialog-bottom"
          v-html="translate('bottom_message')"
        />
      </div>
    </brazil-v-dialog>
    <brazil-v-dialog
      v-if="!showMobile"
      :value="showDialog"
      width="90%"
      @change="closeModal"
    >
      <div id="dialog-body">
        <div id="dialog-top">
          <span
            id="dialog-title"
            v-html="translate('title')"
          />
          <table
            class="installment-row"
          >
            <col style="width:60%">
            <col style="width:20%">
            <col style="width:20%">
            <template v-for="(installment, index) in paymentPlan.installments">
              <tr
                :key="index"
                :class="installmentStatus(installment)"
              >
                <td
                  class="date"
                  v-html="formatDate(installment.due_date)"
                />
                <td
                  class="align-right"
                  v-html="formatAmount(installment.installment_amount)"
                />
                <td
                  :class="statusClass(installmentStatus(installment), index)"
                  class="align-right"
                  v-html="translateStatus(installmentStatus(installment))"
                />
              </tr>
            </template>
          </table>
        </div>
        <div id="dialog-middle">
          <div id="next-payment-container">
            <span
              id="next-payment-title"
              v-html="translate('next_payment')"
            />
            <span
              id="next-payment-amount"
              v-html="formatAmount(nextInstallment.installment_amount)"
            />
            <hr>
            <span
              id="next-payment-date-title"
              v-html="translate('date')"
            />
            <span
              id="next-payment-date"
              v-html="formatDate(nextInstallment.due_date)"
            />
          </div>
          <div id="action-buttons">
            <div id="download-pdf-container">
              <brazil-v-btn
                class="primary-button"
                :loading="loadingPdf"
                :disabled="loadingPdf"
                @click="downloadPdf(nextInstallment.due_date)"
                v-html="showPdfText"
              />
            </div>
            <div id="copy-barcode-container">
              <span
                v-if="showCopyBarcodeErrorMessage"
                id="copy-barcode-error-message"
                class="red-error-message"
                v-html="translate('generic_error')"
              />
              <v-tooltip
                v-model="showBarcodeToolTip"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <brazil-v-btn
                    ref="copyBarcodeButton"
                    class="secondary-button"
                    :loading="loadingBarcode"
                    :disabled="loadingBarcode"
                    v-bind="attrs"
                    @click="copyBarcode(nextInstallment.due_date)"
                    v-on="on"
                  >
                    {{ copyButtonText }}
                  </brazil-v-btn>
                </template>
                <span v-html="translate('copied')" />
              </v-tooltip>
            </div>
            <div
              id="email-button-container"
            >
              <span
                v-if="showEmailErrorMessage"
                id="email-error-message"
                class="red-error-message"
                v-html="translate('generic_error')"
              />
              <v-tooltip
                v-model="showEmailedToolTip"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <brazil-v-btn
                    ref="emailButton"
                    class="secondary-button"
                    v-bind="attrs"
                    :loading="loadingEmail"
                    :disabled="loadingEmail"
                    @click="sendEmail"
                    v-on="on"
                  >
                    {{ translate('email') }}
                  </brazil-v-btn>
                </template>
                <span v-html="translate('emailed')" />
              </v-tooltip>
            </div>
          </div>
        </div>
        <hr>
        <div
          id="dialog-bottom"
          v-html="translate('bottom_message')"
        />
      </div>
    </brazil-v-dialog>
  </div>
</template>
<script>
import { VTooltip } from 'vuetify/lib';
import BrazilVDialog from './BrazilVDialog.vue';
import brazilDateFormat from '../filters/brazilDateFormat';
import currencyReals from '../filters/currencyReals';
import BrazilVBtn from './BrazilVBtn.vue';
import railsAxios from '../lib/railsAxios';
import captureSentryException from '../tracking/sentry/captureSentryException';
import tagRecordings from '../tracking/hotjar/tagRecordings';

const FileSaver = require('file-saver');

export default {
  components: { BrazilVDialog, BrazilVBtn, VTooltip },
  props:      {
    showDialog: {
      type:    Boolean,
      default: false,
    },
    paymentPlanId: {
      type:    String,
      default: null,
    },
  },
  data() {
    return {
      windowWidth:                 window.innerWidth,
      paymentPlan:                 null,
      paymentMethod:               null,
      barcode:                     null,
      showBarcodeToolTip:          false,
      showEmailedToolTip:          false,
      showCopyBarcodeErrorMessage: false,
      showEmailErrorMessage:       false,
      loadingBarcode:              false,
      loadingPdf:                  false,
      loadingEmail:                false,
    };
  },
  computed: {
    showMobile() {
      return this.windowWidth < 700;
    },
    paymentPlans() {
      return this.$store.state.sysopen.paymentPlans;
    },
    nextInstallment() {
      const allInstallments = this.paymentPlan.installments;
      let installments = allInstallments;
      installments = this.lodash.filter(installments,
        (installment) => installment.status !== 'paid_off');
      installments = this.lodash.sortBy(installments,
        (installment) => new Date(installment.due_date));
      return installments[0];
    },
    showCopyButton() {
      return typeof window.navigator !== 'undefined';
    },
    showPdfText() {
      return this.translate(`download_${this.lowerCasePaymentMethod}`);
    },
    copyButtonText() {
      return this.translate(`copy_${this.lowerCasePaymentMethod}_barcode`);
    },
    lowerCasePaymentMethod() {
      return this.paymentMethod.toLowerCase();
    },
  },
  mounted() {
    this.addResizeListener();
  },
  created() {
    this.fetchPaymentPlanDetails(this.paymentPlanId);
  },
  beforeDestroy() {
    this.barcode = null;
    this.resetErrorMessages();
    window.removeEventListener('resize', this.onResize());
  },
  methods: {
    onResize() {
      return () => { this.windowWidth = window.innerWidth; };
    },
    addResizeListener() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize());
      });
    },
    closeModal(value) {
      if (!value) {
        this.$emit('closeModal');
      }
    },
    translate(key) {
      return this.$t(`components.loan_status_modal.${key}`);
    },
    fetchPaymentPlanDetails() {
      const paymentPlan = this.lodash.find(
        this.paymentPlans,
        (plan) => Number(plan.id) === Number(this.paymentPlanId),
      );
      this.paymentPlan = paymentPlan;
      this.paymentMethod = paymentPlan.installments[0].payment_method;
    },
    translateStatus(status) {
      switch (status) {
        case 'paid_off':
          return this.translate('paid_off');
        case 'under_payment_plan':
          return this.translate('under_payment_plan');
        case 'defaulted':
          return this.translate('defaulted');
        case 'pending':
          return this.translate('pending');
        case 'unpaid':
          return this.translate('pending');
        case 'next':
          return this.translate('pending');
        default:
          return '';
      }
    },
    formatDate(dateTime) {
      const date = dateTime.split('T')[0];
      const options = {
        delimiter: '/',
      };
      return brazilDateFormat(date, options);
    },
    formatAmount(amount) {
      return currencyReals(amount);
    },
    statusClass(status, index) {
      if (status === 'next') {
        return 'black';
      }
      if (status !== 'paid_off' && index > 0) {
        return 'gray';
      }
      return 'black';
    },
    isNextInstallment(installment) {
      return installment === this.nextInstallment;
    },
    installmentStatus(installment) {
      if (this.isNextInstallment(installment)) {
        return 'next';
      }

      return installment.status;
    },
    async fetchPDFBase64(installmentDueDate) {
      const endpoint = `/api/v1/payment-plans/pdf-${this.lowerCasePaymentMethod}?payment_plan_id=${this.paymentPlan.id}&installment_due_date=${installmentDueDate}&${Date.now()}`;
      const response = await railsAxios.get(endpoint);
      const base64 = response.data.data.pdf;

      if (typeof base64 === 'undefined' || base64 == null || base64 === '') {
        throw new Error('Failed to fetch base64 PDF string');
      }

      return base64;
    },
    base64ToBlob(data) {
      // decode base64 string, remove space for IE compatibility
      const binary = window.atob(data.replace(/\s/g, ''));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);
      for (let i = 0; i < len; i += 1) {
        view[i] = binary.charCodeAt(i);
      }
      const blob = new Blob([view], { type: 'application/pdf' });
      return blob;
    },
    savePDF(base64) {
      tagRecordings([`sysopen_download_${this.lowerCasePaymentMethod}_pdf`]);
      const blob = this.base64ToBlob(base64);
      FileSaver.saveAs(blob, `${this.lowerCasePaymentMethod}.pdf`);
    },
    async downloadPdf(installmentDueDate) {
      try {
        this.resetErrorMessages();
        this.loadingPdf = true;
        const base64 = await this.fetchPDFBase64(installmentDueDate);
        this.savePDF(base64);
      } catch (e) {
        this.flash(this.$t('shared.generic_error'), 'error');
        const extras = {
          paymentPlanId:   this.paymentPlan.id,
          operationNumber: this.paymentPlan.operation_number,
        };
        captureSentryException(e, extras);
      } finally {
        this.loadingPdf = false;
      }
    },
    async copyBarcode(installmentDueDate) {
      try {
        tagRecordings([`sysopen_copy_${this.lowerCasePaymentMethod}_barcode`]);
        if (this.barcode !== null) {
          navigator.clipboard.writeText(this.barcode);
          this.showBarcodeToolTip = true;
          window.setTimeout(() => { this.showBarcodeToolTip = false; }, 3000);
          return;
        }
        this.loadingBarcode = true;
        this.resetErrorMessages();
        const endpoint = `/api/v1/payment-plans/barcode-${this.lowerCasePaymentMethod}?payment_plan_id=${this.paymentPlan.id}&installment_due_date=${installmentDueDate}&${Date.now()}`;
        const response = await railsAxios.get(endpoint);
        const { barcode } = response.data.data;
        this.barcode = barcode;
        navigator.clipboard.writeText(barcode);
        this.showBarcodeToolTip = true;
        window.setTimeout(() => { this.showBarcodeToolTip = false; }, 3000);
      } catch (e) {
        this.showCopyBarcodeErrorMessage = true;
        const extras = {
          paymentPlanId:   this.paymentPlan.id,
          operationNumber: this.paymentPlan.operation_number,
        };
        captureSentryException(e, extras);
      } finally {
        this.loadingBarcode = false;
      }
    },
    async sendEmail() {
      try {
        tagRecordings([`sysopen_email_${this.lowerCasePaymentMethod}`]);
        this.resetErrorMessages();
        this.loadingEmail = true;
        const installmentDueDate = this.nextInstallment.due_date;
        const endpoint = `/api/v1/payment-plans/email-${this.lowerCasePaymentMethod}?p${Date.now()}`;
        const payload = {
          payment_plan_id:      this.paymentPlan.id,
          installment_due_date: installmentDueDate,
        };
        const response = await railsAxios.post(endpoint, payload);
        const result = response.data.data.email_sent;
        if (result) {
          this.showEmailedToolTip = true;
          window.setTimeout(() => { this.showEmailedToolTip = false; }, 3000);
        } else {
          this.showEmailErrorMessage = true;
        }
      } catch (e) {
        this.showEmailErrorMessage = true;
        const extras = {
          paymentPlanId:   this.paymentPlan.id,
          operationNumber: this.paymentPlan.operation_number,
        };
        captureSentryException(e, extras);
      } finally {
        this.loadingEmail = false;
      }
    },
    resetErrorMessages() {
      this.showCopyBarcodeErrorMessage = false;
      this.showEmailErrorMessage = false;
    },
  },
};
</script>
<style lang="scss" scoped>
  #dialog-title {
    font-size: 1.2em;
    margin-bottom: 0.5em;
    display: block;
    padding-right: 40px;
  }
  #dialog-body {
    padding: 0.75em;
    color: black;
    font-weight: bold;
  }
  hr {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    border-top: 1px solid #b9b9b9;
  }
  .installment-row {
    width: 100%;
    text-align: left;
    color: black;
    &.next {
      background-color: rgb(254, 233, 158);
    }
    &.paid_off {
      color: #387d23;
    }
    td {
      padding: 0.25em 0.5em 0.25em 0.5em;
    }
    .align-right {
      text-align: right;
    }
    .gray {
      color: rgb(116, 119, 124);
    }
  }
  #dialog-middle {
    span {
      display: block;
      text-align: center;
      margin: 0 auto;
    }
    hr {
      width: 20%;
      margin-left: auto;
      margin-right: auto;
      border-top: 1px solid rgb(72, 141, 54);
    }
    .red-error-message {
      color: #c4291c;
      margin: 0.5em auto;
    }
  }
  #next-payment-container {
    margin: 1em auto;
  }
  #next-payment-title {
    color: #387d23;
    font-size: 1.25em;
    font-weight: bold;
  }
  #next-payment-amount {
    color: #387d23;
    font-size: 2em;
    font-weight: bold;
  }
  #next-payment-date-title {
    color: black;
    font-weight: bold;
  }
  #next-payment-date {
    font-weight: 300;
    color: black;
  }
  #dialog-bottom {
    font-weight: 300;
    line-height: 1.2;
    font-size: 0.75em;
    font-style: italic;
  }
  #action-buttons {
    .secondary-button {
      background-color: white;
      border: 1px solid green;
      color: #4a4a4a;
      margin: 0 auto 1em auto;
      max-width: 300px;
      text-transform: none;
      width: 100%;
      display: block;
    }
    .primary-button {
      background-color: rgb(245, 191, 5);
      color: #4a4a4a;
      margin: 0 auto 1em auto;
      max-width: 300px;
      text-transform: none;
      width: 100%;
      display: block;
    }
  }
  @media (min-width: 700px) {
    #dialog-title {
      padding-right: 0;
    }
    .installment-row {
      margin-bottom: 1em;
      td {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        border-bottom: 1px solid #b9b9b9;
      }
      tr.next {
        background-color: rgb(254, 233, 158);
      }
      tr.paid_off {
        color: #387d23;
      }
    }
    #dialog-middle {
      display: flex;
      flex-direction: row;
    }
    #next-payment-container {
      width: 50%;
      margin: 0;
    }
    #action-buttons {
      width: 50%;
    }
  }
</style>
